import React, { Fragment } from 'react';
import { Col } from 'reactstrap';
import Strings from '../../translations/Translations';

export default function Maintenance() {
  const maintenanceMessage = (document.APPLICATION_MAINTENANCE_MESSAGE) ? document.APPLICATION_MAINTENANCE_MESSAGE : Strings('maintenance_default_message');

  return (
    <Fragment>
      <div className="h-100 bg-animation">
        <div className="d-flex h-100 justify-content-center align-items-center">
          <Col md="8" className="mx-auto app-login-box">
            <div className="modal-dialog w-100 mx-auto">
              <div className="modal-content">
                <div className="modal-body">
                  <div className="h5 modal-title text-center">
                    <h4 className="mt-2">
                      <div>{Strings('application_title')}</div>
                    </h4>
                    <h5>
                      {maintenanceMessage}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </div>
      </div>
    </Fragment>
  );
}
